module.exports = __webpack_public_path__ + "img/手动推送.1790bbb3.svg";